export default __webpack_public_path__ + "static/media/illustration-cube-platform.5f517655.svg";